import { Skeleton, TableCell, TableRow, Tooltip } from "@mui/material";
import { Icons, Images } from "assets";
import classNames from "classnames";
import moment from "moment";
import { useState } from "react";
import styles from "pages/phNewPendingTasks/style.module.scss";
import { plan_level_enums } from "shared/utils/constants";
import Modal from "./detailModal";

const SubscriptionRequest = ({ allTasks, loader }: any) => {
  const [openViewReceiptModal, setOpenViewReceiptModal] = useState(false);
  const [openRejectModal, setOpenRejectModal] = useState(false);
  const [openApproveModal, setOpenApproveModal] = useState(false);
  const [showReasonModal, setShowReasonModal] = useState(false);
  const [viewModalImage, setViewModalImage] = useState("");
  const [rejectMessage, setRejectMessage] = useState("");
  const [rejectReason, setRejectReason] = useState("");

  const handleCloseModal = () => {
    setOpenViewReceiptModal(false);
    setOpenRejectModal(false);
    setRejectMessage("");
  };
  const handleSave = () => {};
  const handleConfirmApprove = () => {
    setOpenApproveModal(false);
  };
  // const tasksList = [
  //   {
  //     status: 1,
  //   },
  //   {
  //     status: 2,
  //   },
  //   {
  //     status: 3,
  //   },
  //   {
  //     status: 4,
  //   },
  // ];

  const status_enums = {
    pending: 0,
    approved: 1,
    rejected: 2,
    failed: 3,
    dropped: 4,
  };

  return (
    <>
      {loader ? (
        <Loader />
      ) : (
        allTasks?.map((item: any, index: any, arr: any) => {
          console.log("item", item);

          return (
            <TableRow
              className={classNames(
                index + 1 === arr.length && styles.lastCells
              )}
            >
              <TableCell>{item?.transaction_id}</TableCell>
              <TableCell>
                <div className={styles.nameCell}>
                  <img
                    src={Images.UserPlaceholderImage}
                    alt="profile_picture"
                    className={styles.profilepic}
                  />
                  <div style={{ display: "flex", flexDirection: "column" }}>
                    <label>Jane Doe</label>
                    <label className={styles.emailLabel}>
                      {item?.user?.email}
                    </label>
                  </div>
                </div>
              </TableCell>
              <TableCell>
                {item?.plan?.name ? item?.plan?.name : "--"}
              </TableCell>
              <TableCell>
                {item?.plan?.price
                  ? parseInt(item?.plan?.price)
                  : "Not Provided"}
                {item?.plan?.level === plan_level_enums.in_app_international ||
                item?.plan?.level === plan_level_enums.international
                  ? "$ USD"
                  : " PKR"}
              </TableCell>
              <TableCell>
                {item?.plan?.coins
                  ? parseInt(item?.plan?.coins)
                  : "Not Provided"}
              </TableCell>
              <TableCell>
                {item?.plan?.level === plan_level_enums.in_app_international
                  ? "In App International"
                  : item?.plan?.level === plan_level_enums.inapp
                  ? "In App"
                  : item?.plan?.level === plan_level_enums.general
                  ? "General"
                  : item?.plan?.level === plan_level_enums.international
                  ? "International"
                  : "Not Provided"}
              </TableCell>
              <TableCell>Manual</TableCell>
              <TableCell>
                {" "}
                {item?.transaction_date
                  ? moment(item?.transaction_date).format("DD MMM YYYY")
                  : "Not Provided"}
              </TableCell>
              <TableCell className={classNames(styles.statusCell)}>
                <label
                  className={
                    // item?.status === 1
                    //   ? styles.approved
                    //   : item?.status === 2
                    //   ? styles.rejected
                    //   : item?.status === 3
                    //   ? styles.pending
                    //   : item?.status === 4
                    //   ? styles.neutral
                    //   : ""

                    item?.status === status_enums.approved
                      ? styles.approved
                      : item?.status === status_enums.dropped
                      ? styles.neutral
                      : item?.status === status_enums.pending
                      ? styles.pending
                      : item?.status === status_enums.failed
                      ? styles.rejected
                      : item?.status === status_enums.rejected
                      ? styles.rejected
                      : ""
                  }
                >
                  {item?.status === status_enums.approved
                    ? "Approved"
                    : item?.status === status_enums.dropped
                    ? "Dropped"
                    : item?.status === status_enums.pending
                    ? "Pending"
                    : item?.status === status_enums.failed
                    ? "Failed"
                    : item?.status === status_enums.rejected
                    ? "Rejected"
                    : ""}
                </label>
              </TableCell>
              <TableCell>
                <div className={styles.actionContainer}>
                  <Tooltip
                    componentsProps={{
                      tooltip: { className: "tooltip" },
                      arrow: { className: "arrow" },
                    }}
                    placement="top"
                    arrow
                    title="View Receipt"
                  >
                    <div>
                      <Icons.EyeIcon className={styles.icons} />
                    </div>
                  </Tooltip>

                  <Tooltip
                    componentsProps={{
                      tooltip: { className: "tooltip" },
                      arrow: { className: "arrow" },
                    }}
                    placement="top"
                    arrow
                    title={"Approve"}
                  >
                    <div>
                      <Icons.ApproveIcon />
                    </div>
                  </Tooltip>
                  <Tooltip
                    componentsProps={{
                      tooltip: { className: "tooltip" },
                      arrow: { className: "arrow" },
                    }}
                    placement="top"
                    arrow
                    title={"Reject"}
                  >
                    <div>
                      <Icons.RejectIcon />
                    </div>
                  </Tooltip>
                </div>
              </TableCell>
            </TableRow>
          );
        })
      )}

      {openViewReceiptModal && (
        <Modal
          modalHeading="Receipt View"
          viewOnly={true}
          showButtons={true}
          state={openViewReceiptModal}
          handleClose={handleCloseModal}
          receiptImage={viewModalImage}
          showReceipt={true}
        ></Modal>
      )}
      {openRejectModal && (
        <Modal
          state={openRejectModal}
          modalHeading="Add Reason for Rejection"
          modalText="* Reason will be send to the User"
          viewOnly={false}
          showButtons={true}
          handleClose={handleCloseModal}
          handleConfirm={handleSave}
          showTextArea
          textAreaMsg={rejectMessage}
          textAreaHandler={(e: any) => setRejectMessage(e.target.value)}
        ></Modal>
      )}
      {openApproveModal && (
        <Modal
          modalHeading="Are you sure you want to approve the request?"
          state={openApproveModal}
          handleClose={() => setOpenApproveModal(false)}
          showButtons={true}
          handleConfirm={handleConfirmApprove}
          viewOnly={false}
        ></Modal>
      )}
      {showReasonModal && (
        <Modal
          modalHeading="Reason Of Rejection"
          state={showReasonModal}
          handleClose={() => setShowReasonModal(false)}
          showButtons={true}
          viewOnly={false}
          modalText={rejectReason}
          reject={true}
        ></Modal>
      )}
    </>
  );
};

export default SubscriptionRequest;

const Loader = () => {
  return (
    <>
      {Array.from({ length: 3 }).map((item, index) => {
        return (
          <TableRow className={styles.loadingRow}>
            <TableCell>
              <div style={{ display: "flex", gap: "4px" }}>
                <Skeleton variant="rounded" width={40} height={40} />
                <div
                  style={{
                    display: "flex",
                    gap: "8px",
                    flexDirection: "column",
                    justifyContent: "center",
                  }}
                >
                  <Skeleton variant="rectangular" width={120} height={20} />
                  <Skeleton variant="rectangular" width={120} height={10} />
                </div>
              </div>
            </TableCell>
            <TableCell>
              <Skeleton variant="rounded" width={120} height={10} />
            </TableCell>
            <TableCell>
              <div style={{ display: "flex", gap: "5px" }}>
                <div
                  style={{
                    display: "flex",
                    gap: "10px",
                    flexDirection: "column",
                  }}
                >
                  <Skeleton variant="rectangular" width={120} height={20} />
                  <Skeleton variant="rectangular" width={120} height={20} />
                </div>
                <div
                  style={{
                    display: "flex",
                    gap: "8px",
                    flexDirection: "column",
                  }}
                >
                  <Skeleton variant="rectangular" width={120} height={20} />
                  <Skeleton variant="rectangular" width={120} height={20} />
                </div>
              </div>
            </TableCell>
            <TableCell>
              <Skeleton variant="rounded" width={60} height={10} />
            </TableCell>
            <TableCell>
              <Skeleton variant="rounded" width={60} height={10} />
            </TableCell>

            <TableCell>
              <div className={styles.actionContainer} style={{ gap: "5px" }}>
                <Skeleton variant="circular" width={35} height={35} />
                <Skeleton variant="circular" width={35} height={35} />
                <Skeleton variant="circular" width={35} height={35} />
                <Skeleton variant="circular" width={35} height={35} />
              </div>
            </TableCell>
          </TableRow>
        );
      })}
    </>
  );
};
